<script lang="ts">
    import {Badge} from "flowbite-svelte";

    export let value: string[]
</script>

<div class="flex gap-2">
    {#if !value}
        <Badge color="yellow">Nicht kategorisiert</Badge>
    {:else}
        {#each value.sort() as tag}
            <Badge>{tag}</Badge>
        {/each}
    {/if}

</div>